
import "../CreateClient/CreateClient.css";
import React, { useState, useEffect, Dispatch } from "react";
import { getUsers } from "../../api";

interface ResponseUsersData {
    id: number,
    username: string,
    fullName: string,
    password: string,
    active: boolean
}

type propsData = {
    leadBy: string,
    setLeadBy: Dispatch<React.SetStateAction<string>>,
    soldBy: string,
    setSoldBy: Dispatch<React.SetStateAction<string>>,
    client: any
}

function LeadAndSold({ leadBy, soldBy, setSoldBy, setLeadBy, client }: propsData) {

    const [leadUsers, setLeadUsers] = useState<Array<ResponseUsersData> | undefined>();
    const [soldUsers, setSoldUsers] = useState<Array<ResponseUsersData> | undefined>();

    const getLeadAndSoldUsers = async (): Promise<void> => {
        try{
            const leadAndSoldUsers = await getUsers();
            if (leadAndSoldUsers) {
                setLeadUsers(leadAndSoldUsers.data.leadByUsers.map((user: ResponseUsersData, index: number) => { return { ...user, active: false } }));
                setSoldUsers(leadAndSoldUsers.data.soldByUsers.map((user: ResponseUsersData, index: number) => { return { ...user, active: false } }));
            }
        }
        catch(err) {
            console.log(err);
        }
    }

    useEffect((): void => {
        getLeadAndSoldUsers().then(r => r);
    }, [])

    useEffect((): void => {
        if (client) {
            setLeadBy(client.additionalData.leadBy);
            setSoldBy(client.additionalData.soldBy);
        }
    }, [client])

    return (
        <div className="LeadAndSold">
            <div className="LeadAndSold-select-box">
                <div className="sold-lead-box-dropdown-container">
                    <div className="form-phoneNumber-box">
                        <label className="required" htmlFor=""> Lead By </label>
                    </div>
                    <div className="phoneNumber-box-dropdown-header">
                        <input
                            type = "text"
                            list = "data"
                            className = "leadAndSoldInput"
                            placeholder = ""
                            value = { leadBy }
                            onChange = {e => {
                                setLeadBy(e.target.value);
                            }}
                        />
                        <datalist id = "data">
                            {
                                leadUsers?.map((lead: ResponseUsersData) =>
                                    <option value = { lead.fullName }/>
                                )
                            }
                        </datalist>
                    </div>
                </div>
                <div className="sold-lead-box-dropdown-container">
                    <div className="form-phoneNumber-box">
                        <label className="required" htmlFor=""> Sold By </label>
                    </div>
                    <div className="phoneNumber-box-dropdown-header">
                        <input
                            type = "text"
                            list = "data"
                            className = "leadAndSoldInput"
                            placeholder = ""
                            value = { soldBy }
                            onChange = {e => {
                                setSoldBy(e.target.value);
                            }}
                        />
                        <datalist id = "data">
                            {
                                soldUsers?.map((sold: ResponseUsersData) =>
                                    <option value = { sold.fullName }/>
                                )
                            }
                        </datalist>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LeadAndSold
